import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { label: 'Home', path: '/home-landing', requiresAuth: false },
    { label: 'Pricing', path: '/pricing-plans', requiresAuth: false },
    { label: 'Prompt Generator', path: '/prompt-generator', requiresAuth: true },
    { label: 'Saved Prompts', path: '/saved-prompts', requiresAuth: true },
  ];

  const handleAuthToggle = () => {
    setIsAuthenticated(!isAuthenticated);
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const isActiveRoute = (path) => {
    return location?.pathname === path;
  };

  const visibleNavItems = navigationItems?.filter(item => 
    !item?.requiresAuth || isAuthenticated
  );

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-surface border-b border-border shadow-soft">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16 px-6">
          {/* Logo */}
          <Link to="/home-landing" className="flex items-center space-x-2 hover-scale">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Zap" size={20} color="white" />
            </div>
            <span className="text-xl font-semibold text-text-primary">
              PitchEngine AI
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {visibleNavItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`text-sm font-medium transition-smooth px-3 py-2 rounded-md ${
                  isActiveRoute(item?.path)
                    ? 'text-primary bg-primary/10' :'text-text-secondary hover:text-text-primary hover:bg-muted'
                }`}
              >
                {item?.label}
              </Link>
            ))}
          </nav>

          {/* Desktop Auth Section */}
          <div className="hidden md:flex items-center space-x-4">
            {!isAuthenticated ? (
              <>
                <Link to="/user-authentication">
                  <Button variant="ghost" size="sm">
                    Sign In
                  </Button>
                </Link>
                <Link to="/user-authentication">
                  <Button variant="default" size="sm">
                    Get Started
                  </Button>
                </Link>
              </>
            ) : (
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="User" size={16} color="white" />
                </div>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={handleAuthToggle}
                  iconName="LogOut"
                  iconSize={16}
                >
                  Sign Out
                </Button>
              </div>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={handleMobileMenuToggle}
            className="md:hidden p-2 rounded-md text-text-secondary hover:text-text-primary hover:bg-muted transition-smooth"
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-surface border-t border-border animate-slide-in">
            <nav className="px-6 py-4 space-y-2">
              {visibleNavItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`block px-3 py-2 rounded-md text-sm font-medium transition-smooth ${
                    isActiveRoute(item?.path)
                      ? 'text-primary bg-primary/10' :'text-text-secondary hover:text-text-primary hover:bg-muted'
                  }`}
                >
                  {item?.label}
                </Link>
              ))}
              
              {/* Mobile Auth Section */}
              <div className="pt-4 border-t border-border space-y-2">
                {!isAuthenticated ? (
                  <>
                    <Link 
                      to="/user-authentication"
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block"
                    >
                      <Button variant="ghost" size="sm" fullWidth>
                        Sign In
                      </Button>
                    </Link>
                    <Link 
                      to="/user-authentication"
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block"
                    >
                      <Button variant="default" size="sm" fullWidth>
                        Get Started
                      </Button>
                    </Link>
                  </>
                ) : (
                  <div className="flex items-center justify-between px-3 py-2">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                        <Icon name="User" size={16} color="white" />
                      </div>
                      <span className="text-sm font-medium text-text-primary">Account</span>
                    </div>
                    <Button 
                      variant="ghost" 
                      size="sm" 
                      onClick={handleAuthToggle}
                      iconName="LogOut"
                      iconSize={16}
                    >
                      Sign Out
                    </Button>
                  </div>
                )}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;